import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-rules-box',
  standalone: true,
  imports: [],
  templateUrl: './form-rules-box.component.html',
  styleUrl: './form-rules-box.component.scss',
})
export class FormRulesBoxComponent {
  @Input()
  public title: string = '';

  @Input()
  public rules: Array<{ label: string; valid: boolean }> = [];
}

